// import "./AboutFeature.css";

// export default function AboutFeature() {
//   return (
//     <section className="af-section">
//       <div className="af-container">

//         {/* LEFT SIDE */}
//         <div className="af-left">

//           <p className="af-tag">ABOUT US – NOSH AND NECTAR</p>

//           <h1 className="af-title">
//             Serving Food That’s Worth <span>Coming Back</span> For.
//           </h1>

//           <p className="af-desc">
//             At NOSH AND NECTAR, we focus on one thing: serving food that’s worth 
//             coming back for. We’re a family-run restaurant in Cape Breton, grounded 
//             in the flavors we grew up with and dedicated to cooking everything with 
//             intention—fresh ingredients, bold taste, and zero shortcuts.
//             <br /><br />
//             Our patio looks out over the waterfront, but we don’t rely on the view 
//             to impress you. We earn it with consistent hospitality, clean execution, 
//             and dishes that actually deliver on their promise.
//             <br /><br />
//             Whether you’re here for a quick breakfast, a no-nonsense lunch, a slow 
//             family dinner, or a celebration that deserves better than generic 
//             catering, our goal is straightforward: make you feel at home and make 
//             the food memorable.
//             <br /><br />
//             Thank you for choosing to spend your time with us. We’re ready when you are.
//           </p>

//           {/* ICON ROW */}
//           <div className="af-icons">
//             <div className="af-icon-box">
//               <img src="/icons/leaf.svg" className="af-icon" alt="" />
//               <h4>FRESH INGREDIENTS</h4>
//               <p>Every dish is prepared with care, attention, and zero shortcuts.</p>
//             </div>

//             <div className="af-icon-box">
//               <img src="/icons/table.svg" className="af-icon" alt="" />
//               <h4>COMFORTING AMBIENCE</h4>
//               <p>A warm, welcoming space designed to make you feel at home.</p>
//             </div>
//           </div>

//           {/* BOOKING + BUTTON */}
//           <div className="af-booking">
//             <div>
//               <span className="af-book-title">Booking Request :</span><br />
//               <span className="af-phone">+80 (400) 123 4567</span>
//             </div>

//             <button className="af-btn">LEARN MORE</button>
//           </div>

//         </div>

//         {/* RIGHT SIDE IMAGE */}
//         <div className="af-right">
//           <div className="af-image-circle">
//             <img
//               src="https://images.unsplash.com/photo-1578683010236-d716f9a3f461"
//               alt="fine dining"
//             />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }
import "./AboutFeature.css";

export default function AboutFeature() {
  return (
    <section className="af-section">
      <div className="af-container">

        {/* LEFT SIDE */}
        <div className="af-left">

          <p className="af-tag">ABOUT US – NOSH AND NECTOR</p>

          <h1 className="af-title">
            Serving Proudly in Sydney — <br />
            <span>Celebrating Canadian Flavours Inspired by Italian Cuisine</span>
          </h1>

          <p className="af-desc">
            At Nosh and Nector, we proudly serve Sydney with a heartfelt blend of
            Canadian flavours inspired by Italian cuisine. Our dishes are fresh,
            homemade, and prepared with the highest hygiene standards, ensuring
            quality in every bite.
            <br /><br />
            Enjoy our warm, rustic ambiance that feels like home, whether you’re
            dining inside or relaxing on our waterfront patio with beautiful
            views. We are committed to great food, genuine hospitality, and
            memorable experiences.
            <br /><br />
            Thank you for choosing Nosh and Nector — we are proud to serve you.
          </p>

          {/* ICON ROW */}
          <div className="af-icons">
            <div className="af-icon-box">
              <img src="/icons/leaf.svg" className="af-icon" alt="" />
              <h4>FRESH INGREDIENTS</h4>
              <p>
                Fresh, homemade dishes prepared with care, quality ingredients,
                and strict hygiene standards.
              </p>
            </div>

            <div className="af-icon-box">
              <img src="/icons/table.svg" className="af-icon" alt="" />
              <h4>WARM AMBIENCE</h4>
              <p>
                A cozy, welcoming space designed for relaxed dining and
                memorable moments.
              </p>
            </div>
          </div>

          {/* BOOKING + BUTTON */}
          <div className="af-booking">
            <div>
              <span className="af-book-title">Booking Request :</span><br />
              <span className="af-phone">+1 902 270 2572</span>
            </div>

            <a href="tel:+19022702572" className="af-btn">
              Connect to Call
            </a>
          </div>

        </div>

        {/* RIGHT SIDE IMAGE */}
        <div className="af-right">
          <div className="af-image-circle">
            <img
              src="assets/resto_images/resto_image.png"
              alt="fine dining"
            />
          </div>
        </div>

      </div>
    </section>
  );
}
